export const CHECKOUT_RETURN_KEY = 'cevee_checkout_return';

export function setCheckoutReturn(path: string): void {
  try {
    sessionStorage.setItem(CHECKOUT_RETURN_KEY, path);
  } catch {
    /* private mode */
  }
}

export function consumeCheckoutReturn(fallback = '/profile'): string {
  try {
    const raw = sessionStorage.getItem(CHECKOUT_RETURN_KEY);
    sessionStorage.removeItem(CHECKOUT_RETURN_KEY);
    if (raw && raw.startsWith('/') && !raw.startsWith('//')) return raw;
  } catch {
    /* private mode */
  }
  return fallback;
}
